import React, { useState, useEffect, useRef } from "react";
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, useMap, Tooltip, LayerGroup, LayersControl, Polyline, GeoJSON, CircleMarker } from 'react-leaflet';
import axios from 'axios';
import 'leaflet/dist/leaflet.css';
import { Pannellum } from "pannellum-react";
import { API_URL } from '../helpers/config';
import { useTranslation } from 'react-i18next';

// Custom Map Icons
import markergif from "../gifts/map_pin.gif";
import necropolis from "../map_Information/necropolis.json"
import necropolisbaja from "../map_Information/necropolisbaja.json"
import meseta1 from "../map_Information/meseta1.json"
import meseta2 from "../map_Information/meseta2.json"
import meseta3 from "../map_Information/meseta3.json"
import meseta4 from "../map_Information/meseta4.json"
import meseta5 from "../map_Information/meseta5.json"
import cementerioantiguo from "../map_Information/cementerioantiguo.json"
import ampliacion from "../map_Information/ampliacion.json"
import recorridoNichos from "../map_Information/recorrido_nichos.json"

//Debemos editar los parametros iniciales de React-Leaflet para que no de errores
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/1948/1948830.png',//también podemos utilizar imagenes por defecto "../images/images_leaflet/marker-icon-2x.png ,etc."
  iconRetinaUrl: 'https://cdn-icons-png.flaticon.com/512/1948/1948830.png',
  shadowUrl: 'https://cdn-icons-png.flaticon.com/512/1948/1948830.png',
  shadowSize: [0, 0],
  iconSize: [6, 6], // size of the icon
  iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
  popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
});
//icono punto inicial centro almudena
var Cementerioal = new L.icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/3448/3448381.png',
  iconSize: [50, 50], // size of the icon
  iconAnchor: [25, 45], // poscicion del icono
  popupAnchor: [0, -30] //poscicion del popup
});

var informationPin = new L.icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/5165/5165235.png',
  iconSize: [25, 25], // size of the icon
  iconAnchor: [7, 10], // poscicion del icono
  popupAnchor: [3, -6] //poscicion del popup
});

//icono tamaño apidata
var apiicon = new L.icon({
  iconUrl: markergif,
  iconSize: [100, 100], // size of the icon
  iconAnchor: [50, 56], // poscicion del icono
  popupAnchor: [0, -28] //poscicion del popup
});
//icono tamaño apidata
var metro = new L.icon({
  iconUrl: 'https://miro.medium.com/max/828/1*LJGehYBxDIpDvRiCgQB5XA.png',
  iconSize: [40, 30], // size of the icon
  iconAnchor: [7, 10], // poscicion del icono
  popupAnchor: [3, -6] //poscicion del popup
});

//Se crea funciones para poder editar el mapa(general) en rect-Leaflet y asi utilizamos propiedades como las que podemos obtener de leaflet
function ChangeView({ center, zoom }) {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}

const RecorridoPopupContent = ({ pointId, onNavigate }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [viewImage, setViewImage] = useState(false);
  const panRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);
    
    axios.get(`${API_URL}/nichosycol/${pointId}`)
      .then(response => {
        if (isMounted) {
          setData(response.data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (isMounted) {
          console.error("Error fetching recorrido point details:", err);
          setError("Error al cargar datos");
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [pointId]);

  useEffect(() => {
    const handleResize = () => {
      if (panRef.current && panRef.current.getViewer()) {
        try {
          panRef.current.getViewer().resize();
        } catch (e) {
          console.error("Error resizing Pannellum:", e);
        }
      }
    };

    window.addEventListener('resize', handleResize);
    // Trigger a resize check immediately with a slight delay when viewer state becomes active
    if (viewImage) {
      setTimeout(handleResize, 150);
      setTimeout(handleResize, 500);
    }
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [viewImage]);

  if (loading) {
    return (
      <div className="recorrido-popup-loader">
        <div className="recorrido-popup-spinner"></div>
        <span>Cargando...</span>
      </div>
    );
  }

  if (error || !data) {
    return <div className="recorrido-popup-text" style={{ color: '#ff6b6b' }}>{error || "Error"}</div>;
  }

  const hasImage = data.imagenequi && data.imagenequi !== 'null';

  return (
    <div className="recorrido-popup-container">
      <div className="recorrido-popup-title">Punto Recorrido #{data.id}</div>
      
      {!hasImage ? (
        <div className="recorrido-popup-text">
          Este punto no tiene imagen panorámica asociada.
        </div>
      ) : (
        <>
          {viewImage ? (
            <div>
              <div className="recorrido-popup-image-container">
                <Pannellum
                  ref={panRef}
                  width="100%"
                  height="100%"
                  image={`${API_URL}/image-nicho/${data.imagenequi}`}
                  pitch={0}
                  yaw={0}
                  hfov={100}
                  minPitch={-32}
                  maxPitch={35}
                  mouseZoom={true}
                  showZoomCtrl={true}
                  showControls={true}
                  autoLoad
                />
              </div>
              <button 
                className="recorrido-popup-btn back-btn" 
                onClick={() => setViewImage(false)}
              >
                Volver
              </button>
            </div>
          ) : (
            <div className="recorrido-popup-buttons">
              <button 
                className="recorrido-popup-btn primary" 
                onClick={() => {
                  if (onNavigate && data?.imagenequi) {
                    const cleanNicheId = parseInt(String(data.imagenequi).replace(/[^0-9]/g, ''), 10) || 1;
                    onNavigate(cleanNicheId + 100000);
                  }
                }}
              >
                Navegar (360°)
              </button>
              <button 
                className="recorrido-popup-btn secondary" 
                onClick={() => setViewImage(true)}
              >
                Ver Imagen
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

// Componente LeafMap
const LeafMap = ({markerPosition,zoomBefore,tittlepopup,popup,mapaind,onNavigate}) => {
  const { t } = useTranslation();
  const [tumbasPanteonesData, setTumbasPanteonesData] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/tumbasypanteones`, {
      headers: { 'x-access-token': localStorage.getItem('token') || '' }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setTumbasPanteonesData(data);
      })
      .catch(err => console.error("Error fetching tumbas:", err));
  }, []);

  return (
<MapContainer scrollWheelZoom={true}>

<ChangeView center={markerPosition} zoom={zoomBefore} />


<TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution="&copy; <a href=&quot;https://www.arcgis.com/home/item.html?id=10df2279f9684e4a9f6a7f08febac2a9&quot;>Esri World Imagery</a>" />


<LayersControl position="topleft">

  <LayersControl.Overlay checked name={t('layerPointsOfInterest')}>
    <LayerGroup>

      <Marker position={[40.422357131834765, -3.6442531730111885]}
        icon={Cementerioal}
      >
        <Popup>
          El cementerio de Nuestra Señora de la Almudena es la principal necrópolis de la ciudad española de Madrid, ubicado en el barrio de Ventas del distrito de Ciudad Lineal. Con 120 hectáreas de extensión, es el cementerio más grande de toda Europa Occidental.
        </Popup>
        <Tooltip direction="bottom" offset={[1, 10]} permanent opacity={1}> {'Pulse las etiquetas para obtener más información'} </Tooltip>
      </Marker>
      <Marker position={markerPosition}
        icon={apiicon}
      >
        <Popup ><div className="a"><b> {tittlepopup}</b></div>
          {popup}  </Popup>

      </Marker >
      <Marker position={[40.425695907235394, -3.6459284895638557]}
        icon={informationPin}>
        <Popup className="custom-popup">
          

          <Pannellum
            height="500px"
            width="500px"
            minPitch={-50}
            // image={`${API_URL}/image-data/8`}//en el mapa se representa la imagen de la imgane de prueba 
            image="/entrada.jpg"
            compass={true}
            hotspotDebug={false}
            mouseZoom={true}
            showZoomCtrl={true}
            showControls={true}
            autoLoad
          >
            {/*Falta añadir los datos de los yaw y pitch*/}
            {/*
                      <Pannellum.Hotspot
                        key={"infoHotspot"} 
                        type={"custom"}
                        cssClass={"hotSpotElement"} 
                        tooltip={hotspotIconInfo} 
                        handleClick={() => alert("Información del hotspot")}
                      /> Esta es para solo los datos que se obtienen en el mapa  */}
            
          </Pannellum>
          <div>
      <span style={{ fontSize: '24px', fontWeight: 'bold' }}>Entrada principal</span><br />
      <span style={{ fontSize: '12px' }}>Esta es la fachada histórica desde 1800</span>
    </div>
        </Popup>
      </Marker>
      <Marker position={[40.42602246914886, -3.6448247481537566]}
        icon={informationPin}>
        <Popup>
          Parada de bus exterior <br /><b>Numero: 1082</b>
        </Popup>
      </Marker>
      <Marker position={[40.42653499829007, -3.6506470047743305]}
        icon={metro}>
        <Popup>
          Parada de Metro:<br /><b>La Elipa</b>
        </Popup>
      </Marker>

    </LayerGroup>
  </LayersControl.Overlay >
  <LayersControl.Overlay checked name={t('layerHowToGetThere')}>
    <Polyline positions={mapaind} pathOptions={{ color: '#ff0000' }} />

  </LayersControl.Overlay>
  <LayersControl.Overlay name={t('layerBusRoute110')}>
    <LayerGroup>
      <Marker position={[40.41812403693542, -3.647300063118203]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Cementerio Almudena 1</b>
        </Popup>
      </Marker>
      <Marker position={[40.417575321092116, -3.6448034263053537]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Cementerio Almudena 2</b>
        </Popup>
      </Marker>
      <Marker position={[40.41719744919881, -3.6414212734872438]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Cementerio Almudena 3</b>
        </Popup>
      </Marker>
      <Marker position={[40.41762064458173, -3.6378459011157886]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Cementerio Almudena 4</b>
        </Popup>
      </Marker>
      <Marker position={[40.428887917955464, -3.6694402384114446]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Manuel Becerra </b>
        </Popup>
      </Marker>

      <Marker position={[40.429089228015734, -3.666490873873396]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Alcalá - Parque Bomberos</b>
        </Popup>
      </Marker>
      <Marker position={[40.43064356940025, -3.663420031698785]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Ventas</b>
        </Popup>
      </Marker>
      <Marker position={[40.43078391756351, -3.657970594992468]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Avenida De Daroca - Ricardo Ortiz</b>
        </Popup>
      </Marker>
      <Marker position={[40.42747573100127, -3.658152138432088]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Ricardo Ortiz - San Marcelo</b>
        </Popup>
      </Marker>
      <Marker position={[40.42532531795185, -3.657930799330992]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Ricardo Ortiz - San Emilio </b>
        </Popup>
      </Marker>
      <Marker position={[40.42373483616155, -3.657391247454889]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Ricardo Ortiz - San Secundino</b>
        </Popup>
      </Marker>
      <Marker position={[40.422805051005845, -3.655771461593035]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Marqués De Corbera - Ricardo Ortiz</b>
        </Popup>
      </Marker>
      <Marker position={[40.424329121188954, -3.6536519317621474]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Marqués De Corbera - Montejurra</b>
        </Popup>
      </Marker>
      <Marker position={[40.42586621732711, -3.6516644835424468]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Marqués De Corbera - Gerardo Cordón</b>
        </Popup>
      </Marker>
      <Marker position={[40.42654827855424, -3.6499101310128026]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Santa Felicidad - Iglesia</b>
        </Popup>
      </Marker>
      <Marker position={[40.42428744770115, -3.6507929781336808]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Santa Felicidad</b>
        </Popup>
      </Marker>
      <Marker position={[40.422258816644565, -3.6518529376081963]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Blas De Otero - Santa Genoveva</b>
        </Popup>
      </Marker>
      <Marker position={[40.42050277209983, -3.653014041155107]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Blas De Otero - Santa Irene</b>
        </Popup>
      </Marker>
      <Marker position={[40.42050277209983, -3.653014041155107]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Blas De Otero - Santa Irene</b>
        </Popup>
      </Marker>
      <Marker position={[40.41951268375217, -3.652210872581878]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Santa Irene</b>
        </Popup>
      </Marker>
      <Marker position={[40.41849147321457, -3.6500760809610635]}
        icon={informationPin}>
        <Popup>
          Nombre Parada: <br /><b> Santa Irene - Trece Rosas</b>
        </Popup>
      </Marker>



    </LayerGroup>

  </LayersControl.Overlay>

  <LayersControl.Overlay name={t('layerGeneralInfo')}>
    <LayerGroup>
      <GeoJSON data={necropolis} pathOptions={{ color: '#9EFF36' }}>
        <Tooltip sticky>
          Necropolis
        </Tooltip>
      </GeoJSON>
      <GeoJSON data={necropolisbaja} pathOptions={{ color: '#DDFF99' }}>
        <Tooltip sticky>
          Necropolis Baja
        </Tooltip >
      </GeoJSON>
      <GeoJSON data={meseta1} pathOptions={{ color: 'lightblue' }}>
        <Tooltip sticky>
          Meseta 1
        </Tooltip>
      </GeoJSON>
      <GeoJSON data={meseta2} pathOptions={{ color: '#FF6101' }}>
        <Tooltip sticky>
          Meseta 2
        </Tooltip >
      </GeoJSON>
      <GeoJSON data={meseta3} pathOptions={{ color: 'orange' }}>
        <Tooltip sticky>
          Meseta 3
        </Tooltip>
      </GeoJSON>
      <GeoJSON data={meseta4} pathOptions={{ color: '#DD6F01' }}>
        <Tooltip sticky>
          Meseta 4
        </Tooltip>
      </GeoJSON>
      {/*<CircleMarker
center={[40.422357131834765, -3.6442531730111885]}
pathOptions={{ color: 'red' }}
radius={20}>
<Tooltip>Tooltip for CircleMarker</Tooltip>
</CircleMarker>*/}
      <GeoJSON data={meseta5} pathOptions={{ color: 'red' }}>
        <Tooltip sticky>
          Meseta 5
        </Tooltip>
      </GeoJSON>
      <GeoJSON data={cementerioantiguo} pathOptions={{ color: '#C27BF9' }}>
        <Tooltip sticky>
          Cementerio Antiguo
        </Tooltip>
      </GeoJSON>
      <GeoJSON data={ampliacion} pathOptions={{ color: '#F996CA' }}>
        <Tooltip sticky>
          Ampliación del Cementerio
        </Tooltip>
      </GeoJSON>

    </LayerGroup>
  </LayersControl.Overlay>
  <LayersControl.Overlay name={t('layerNichesColumbariums')}>
    <LayerGroup>
      <Polyline 
        positions={recorridoNichos.map(p => [p.lat, p.lng])} 
        pathOptions={{ color: '#007cff', weight: 6, opacity: 0.8 }} 
      />
      {recorridoNichos.map((point) => (
        <CircleMarker
          key={point.id}
          center={[point.lat, point.lng]}
          radius={6}
          pathOptions={{
            color: '#005cbd',
            fillColor: '#ffffff',
            fillOpacity: 1,
            weight: 2
          }}
          eventHandlers={{
            click: (e) => {
              const map = e.target._map;
              if (map) {
                const targetPoint = map.project([point.lat, point.lng], map.getZoom());
                targetPoint.y -= 200;
                const targetLatLng = map.unproject(targetPoint, map.getZoom());
                map.panTo(targetLatLng);
              }
            }
          }}
        >
          <Popup className="recorrido-popup" minWidth={280} maxWidth={800}>
            <RecorridoPopupContent pointId={point.id} onNavigate={onNavigate} />
          </Popup>
        </CircleMarker>
      ))}
    </LayerGroup>
  </LayersControl.Overlay>
  <LayersControl.Overlay name="Tumbas y panteones">
    <LayerGroup>
      {tumbasPanteonesData.filter((_, idx) => idx % 2 === 0).map((point) => (
        <CircleMarker
          key={`tumba-${point.id}`}
          center={[point.lat, point.lng]}
          radius={4}
          pathOptions={{
            color: '#0033a0',
            fillColor: '#ffffff',
            fillOpacity: 1,
            weight: 2
          }}
          eventHandlers={{
            click: () => {
              if (onNavigate) {
                // Abre el 'visitar sepultura' directamente (navega al 360 de esa tumba)
                onNavigate(Number(point.id));
              }
            }
          }}
        >
          <Tooltip sticky>Tumba / Panteón (Click para visitar sepultura)</Tooltip>
        </CircleMarker>
      ))}
    </LayerGroup>
  </LayersControl.Overlay>


</LayersControl>
</MapContainer>

  );
};

export default LeafMap;